import { dispatchToCustomerImport } from './excel-import-modal-config';

export const excelImportConfig = {
    dispatchToCustomerImport : dispatchToCustomerImport
};